import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./redux/store";
import "./index.css";
import ErrorBoundary from "./components/ErrorBoundary";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// NOTIFY-F006 (docs/TRD/task-notifications-contract.md §6, source TRD D9, R6, AC-F6.1).
// Registration only — see public/service-worker.js for the push-only handlers themselves.
// Behind the feature-detect and after `load` (never blocking first paint); `.catch()`
// leaves the bell (the guaranteed, P0 channel) fully functional if registration fails for
// any reason — push is an accelerator over the bell, never a hard dependency.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {
      // Intentionally silent: push registration failing must not surface as an app error
      // (AC-F6.1). The bell keeps working via the P0 polling path regardless.
    });

    // The other half of pushsubscriptionchange rotation self-healing (source TRD §3.8):
    // the worker cannot attach a bearer token itself, so it hands the new subscription to
    // an open client via postMessage and this listener forwards it to the API.
    navigator.serviceWorker.addEventListener("message", (event) => {
      if (event.data?.type === "push-resubscribed" && event.data.subscription) {
        import("./API")
          .then(({ subscribePush }) => {
            const { endpoint, keys } = event.data.subscription;
            return subscribePush({ endpoint, keys, user_agent: navigator.userAgent });
          })
          .catch(() => {
            // Best-effort re-subscribe POST; a missed one self-heals on the user's next
            // visit via PushSettings.js's own getSubscription()/subscribe() path.
          });
      }
    });
  });
}
